// src/components/blocks/Landing.jsx
import React, { useContext, useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DeckContext } from '../../context/DeckContextV3';
import BaseBlock from './BaseBlockV3';
import EdgeIndicator from './edgeIndicatorV3/EdgeIndicatorV3';
import { formatFeetInches } from '../../utils/measurementUtils';
import { LandingBlockProps } from '../../../../../../types/shared/propsV3';
import EDGE_WIDTH from '../../../../../../constants/edgeWidth';

const Landing: React.FC<LandingBlockProps> = ({
	label,
	landing,
	onSelect,
	onUpdateBlock,
	setIsDragging,
}) => {
	const { state, dispatch } = useContext(DeckContext);
	const nodeRef = useRef(null); // Create a ref for the DOM node

	const { scaleFactor } = state;

	const landingWidth = landing.displayDimensions.width;
	const landingHeight = landing.displayDimensions.height;

	return (
		<BaseBlock
			block={landing}
			onSelect={onSelect}
			onUpdateBlock={onUpdateBlock}
			setIsDragging={setIsDragging}
			disabled={false} // Always draggable
			nodeRef={nodeRef} // Pass nodeRef to BaseBlock
		>
			<Box
				ref={nodeRef} // Attach nodeRef to the DOM node
				style={{ transform: `rotate(${landing.rotation || 0}deg)` }}
				sx={{
					width: landingWidth * scaleFactor, // e.g., 40px
					height: landingHeight * scaleFactor, // e.g., 40px
					bgcolor: '#FFB200', // Orange background
					cursor: 'pointer',
					position: 'absolute',
					border: '0.5px solid rgba(255, 255, 255, 0.1)',
				}}
				onClick={(e) => {
					e.stopPropagation();
					onSelect(landing);
				}}
				onTouchStart={(e) => {
					e.stopPropagation();
				}}
				onTouchEnd={(e) => {
					e.stopPropagation();
					e.preventDefault();
					onSelect(landing);
				}}
			>
				<Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
					{/* Edge Indicators */}
					{landing.edges.map((edge) => (
						<EdgeIndicator
							key={edge.label}
							edge={edge}
							onSelectEdge={(label) => {
								dispatch({
									type: 'SELECT_BLOCK',
									payload: landing,
								});

								dispatch({
									type: 'SELECT_EDGE',
									payload: { blockId: landing.id, edgeLabel: label },
								});
							}}
							isSelected={
								state.selectedEdge?.blockId == landing.id &&
								state.selectedEdge?.edgeLabel === edge.label
							}
							parentIsSelected={state.selectedBlock?.id === landing.id}
						/>
					))}
					<Box
						sx={{
							width: '100%',
							display: 'flex',
							justifyContent: 'center',
							paddingTop: `${EDGE_WIDTH + 5}px`,
							cursor: 'pointer',
						}}
						onClick={(e) => {
							e.stopPropagation();
							onSelect(landing);
						}}
						onTouchStart={(e) => {
							e.stopPropagation();
						}}
						onTouchEnd={(e) => {
							e.stopPropagation();
							e.preventDefault();
							onSelect(landing);
						}}
					>
						<Typography
							variant="caption"
							position="absolute"
							lineHeight={1.15}
							color="rgba(0, 0, 0, 0.6)"
							noWrap
							maxWidth={landingWidth}
							zIndex={10}
						>
							<p>
								<b>{label}</b>
							</p>
							{formatFeetInches(landing.dimensions.depth)}
							<span className="px-0.5">&times;</span>
							{formatFeetInches(landing.dimensions.width)}
						</Typography>
					</Box>
				</Box>
			</Box>
		</BaseBlock>
	);
};

export default Landing;
